import { render, staticRenderFns } from "./v80a1070.vue?vue&type=template&id=04b82fdb&scoped=true"
import script from "./v80a1070.vue?vue&type=script&lang=js"
export * from "./v80a1070.vue?vue&type=script&lang=js"
import style0 from "./v80a1070.vue?vue&type=style&index=0&id=04b82fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b82fdb",
  null
  
)

export default component.exports